/**
 * `/organization/permissions` — «Utenti e ruoli»: i ruoli (permessi) di tutte le utenze dell'azienda,
 * dipendenti ed esterni (23-10-2026). Nata come «Autorizzazioni», la scheda di Lares `/hr-authorizations`.
 *
 * La pagina sta in `features/organization/permissions/`; la stessa sul telefono, che è responsiva.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AuthorizationsPage } from '@/features/organization/permissions/AuthorizationsPage';

/** `?invite=1` apre «Invita un esterno»: ci rinvia `/users/new`, che era la pagina dell'invito. */
interface PermissionsSearch { invite?: boolean }

export const Route = createFileRoute('/_app/organization/permissions')({
  validateSearch: (s: Record<string, unknown>): PermissionsSearch => ({
    invite: s.invite === true || s.invite === 1 || s.invite === '1' || s.invite === 'true' ? true : undefined,
  }),
  component: AuthorizationsPage,
});
